module.exports = __webpack_public_path__ + "img/dash_icon.92d050b3.svg";